/* The chosen size, over the product gallery.

   snippets/product-gallery.liquid renders the chip with the size the page
   loaded on. That would be the end of it, except the product section carries
   allow-partial-rerender: Impact swaps only the elements marked with a
   data-block-type when a variant changes, and the gallery is not one of them.
   So the markup is right on arrival and then goes stale the moment a size is
   picked - which is exactly when it matters.

   Hence this: re-read the size on every change and write it back. Deliberately
   the picker's own checked radio rather than the variant JSON, because the
   radio is what the shopper just pressed, and it is correct before the section
   has finished re-rendering around it.

   The size option is matched by name against the same locale string
   snippets/variant-picker.liquid uses, so a shop that renames it stays in step,
   with a shape test as the fallback for an option that is a size in all but
   name. */
(function () {
  "use strict";

  var SIZE_SHAPE = /^(?:[2-5]?X{0,3}[SLM]|XXS|XS|S|M|L|XL|XXL|\d{2,3})$/i;

  class ProductSizeChip extends HTMLElement {
    connectedCallback() {
      this.formId = this.getAttribute("data-form");
      this.label = (this.getAttribute("data-option-label") || "").toLowerCase();
      this.onChange = this.onChange.bind(this);
      /* The picker inputs are associated with the form but can sit outside it
         in the DOM, so the listener goes on the document - the same reason
         assets/surname-preview.js listens there. */
      document.addEventListener("change", this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener("change", this.onChange);
    }

    picker() {
      if (!this.formId) return null;
      return document.querySelector('variant-picker[form-id="' + this.formId + '"]');
    }

    onChange() {
      var picker = this.picker();
      if (!picker) return;

      var fieldsets = picker.querySelectorAll(".variant-picker__option");
      for (var i = 0; i < fieldsets.length; i++) {
        var legend = fieldsets[i].querySelector("legend");
        var name = legend ? legend.textContent.replace(":", "").trim().toLowerCase() : "";
        var checked = fieldsets[i].querySelector("input:checked");
        if (!checked) continue;

        var value = (checked.nextElementSibling && checked.nextElementSibling.textContent || "").trim();
        if (!value) continue;

        var isSize = this.label ? name === this.label : fieldsets[i].classList.contains("variant-picker__option--size");
        if (isSize || (!this.label && SIZE_SHAPE.test(value))) {
          this.textContent = value;
          /* Empty and hidden until a size is chosen (snippets/product-gallery.liquid);
             this is the moment one is. */
          this.hidden = false;
          return;
        }
      }
    }
  }

  if (!customElements.get("product-size-chip")) {
    customElements.define("product-size-chip", ProductSizeChip);
  }
})();
